import RequirementTable from "./RequirementTable";

export default RequirementTable;
